import type { FC } from "react";

import { PageList } from "./PageList";
import { PublishingCard } from "./PublishingCard";
import { TopicSummary } from "./TopicSummary";

import { type PageChangeSummary, type PublicationSummary } from "api/api-types-publishing";
import { t } from "i18n/i18n";

interface ChangeSummaryProps {
  summary: PublicationSummary;
  sectionId: string;
}

interface PageCategorySectionProps {
  title: string;
  pages: PageChangeSummary[];
  sectionId: string;
}

const PageCategorySection: FC<PageCategorySectionProps> = ({ title, pages, sectionId }) => {
  if (pages.length === 0) return null;

  return (
    <div className="flex flex-col gap-4">
      <h3>{title}</h3>
      <PublishingCard>
        <PageList pages={pages} sectionId={sectionId} />
      </PublishingCard>
    </div>
  );
};

export const ChangeSummary: FC<ChangeSummaryProps> = ({ summary, sectionId }) => {
  return (
    <div className="flex flex-col gap-6 text-black-tint-20">
      {summary.topics.length > 0 && (
        <div className="flex flex-col gap-4">
          <h3>{t("publishing.topics_changed", { count: summary.topics.length })}</h3>
          <div className="flex flex-col gap-4">
            {summary.topics.map((topic) => (
              <TopicSummary key={topic.id} sectionId={sectionId} topic={topic} />
            ))}
          </div>
        </div>
      )}

      <PageCategorySection
        pages={summary.assignments}
        sectionId={sectionId}
        title={t("publishing.assignments_changed", { count: summary.assignments.length })}
      />
      <PageCategorySection
        pages={summary.resources}
        sectionId={sectionId}
        title={t("publishing.resources_changed", { count: summary.resources.length })}
      />
      <PageCategorySection
        pages={summary.workspaces}
        sectionId={sectionId}
        title={t("publishing.workspaces_changed", { count: summary.workspaces.length })}
      />
    </div>
  );
};
